/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPause,
  faPlay,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import './audio.style.scss';

/**
 * Class representing the audio component.
 * @extends Component
 * */
@inject('commonStore')
@observer
class Audio extends Component {

  static propTypes = {
    commonStore: PropTypes.shape({
      audioRefs: PropTypes.arrayOf(PropTypes.shape({})),
      addAudioRef: PropTypes.func,
    }),
    format: PropTypes.string,
    isUploading: PropTypes.bool,
    url: PropTypes.string.isRequired,
  };

  static defaultProps = {
    commonStore: {},
    format: 'audio/mp3',
    isUploading: false,
  };

  audioRef = React.createRef();

  audioSourceRef = React.createRef();

  state = {
    isPaused: true,
    isBuffering: false,
  };

  /**
   * Stops any previous played audio and plays the clicked one.
   * */
  onPlayClick = () => {
    const { commonStore: { stopOtherAudios }, url } = this.props;
    stopOtherAudios(this.audioRef);

    this.audioSourceRef.src = url;
    this.audioRef.load();
    this.audioRef.play();
  };

  /**
   * Pause the clicked audio.
   * */
  onPauseClick = () => {
    this.audioRef.pause();
  };

  /**
   * On audio play ended, updates the local state.
   * */
  onEnded = () => {
    const { commonStore: { updateProgress } } = this.props;

    updateProgress();
    this.setState({ isPaused: true, isBuffering: false });
  };

  /**
   * On audio start playing, updates the local state.
   * */
  onPlay = () => this.setState({ isPaused: false, isBuffering: true });

  /**
   * On audio paused, updates the local state.
   * */
  onPause = () => this.setState({ isPaused: true, isBuffering: false });

  /**
   * On audio playing, updates the local state.
   * */
  onPlaying = () => this.setState({ isBuffering: false });

  /**
   * On audio waiting, updates the local state.
   * */
  onWaiting = () => this.setState({ isBuffering: true });

  /**
   * On audio time update, updates the audio progress.
   * */
  onTimeUpdate = () => {
    const { commonStore: { updateProgress } } = this.props;

    updateProgress(this.audioRef);
  };

  /**
   * Sets the current ref and adds the ref to list of refs.
   * @param {object} node - The current node.
   * */
  handleAudioRef = (node) => {
    const { commonStore: { addAudioRef } } = this.props;

    addAudioRef(node);
    this.audioRef = node;
  };

  render() {
    const { format, isUploading } = this.props;
    const { isPaused, isBuffering } = this.state;

    return (
      <div className="audio-player">
        {!isUploading && isPaused && (
          <button type="button" className="btn btn-outline-secondary btn-link btn-play" onClick={this.onPlayClick}>
            <FontAwesomeIcon icon={faPlay} size="lg" />
          </button>
        )}
        {!isPaused && !isBuffering && (
          <button type="button" className="btn btn-link btn-pause" onClick={this.onPauseClick}>
            <FontAwesomeIcon icon={faPause} size="lg" />
          </button>
        )}
        {!isPaused && isBuffering && (
          <button type="button" className="btn btn-link btn-spin">
            <FontAwesomeIcon icon={faSpinner} size="lg" spin />
          </button>
        )}
        {isUploading && (
          <button type="button" className="btn btn-link btn-upload">
            <span className="pulse" />
          </button>
        )}
        {isUploading !== undefined && !isUploading && (
          <audio
            className="hidden"
            onEnded={this.onEnded}
            onPause={this.onPause}
            onPlay={this.onPlay}
            onPlaying={this.onPlaying}
            onTimeUpdate={this.onTimeUpdate}
            onWaiting={this.onWaiting}
            ref={(node) => { this.handleAudioRef(node); }}
          >
            <source
              ref={(node) => { this.audioSourceRef = node; }}
              type={format}
            />
          </audio>
        )}
      </div>
    );
  }
}

export default Audio;



// WEBPACK FOOTER //
// ./src/common/components/audio/audio.component.js